import { render, staticRenderFns } from "./video-setting.vue?vue&type=template&id=7cae4b96&scoped=true&lang=pug"
import script from "./video-setting.vue?vue&type=script&lang=js"
export * from "./video-setting.vue?vue&type=script&lang=js"
import style0 from "./video-setting.vue?vue&type=style&index=0&id=7cae4b96&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cae4b96",
  null
  
)

/* custom blocks */
import block0 from "./video-setting.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports